export default __webpack_public_path__ + "static/media/banner.56163481.png";